import { IEvents } from "@/models/IEvents";
import { ExternalLink, MapPin } from "lucide-react";
import LillySpeakers from "./LillySpeakers";
import {
  formatEventDateRange,
  parseApiDate,
} from "../../../../../../utils/date";

const EventTileDrawer = ({ data }: { data: IEvents }) => {
  const d = parseApiDate(data.startDate);
  // const getWeekday = (dateStr: string) => {
  //     const date = new Date(dateStr);
  //     return date.toLocaleDateString("en-US", { weekday: "short" });
  // };
  return (
    <div className="py-4 md:px-8 px-4 flex flex-col gap-4 h-full">
      <div className="grid grid-cols-1 md:grid-cols-4 items-center pr-4 gap-4">
        <div className="text-2xl leading-8 font-semibold text-[#0F1B21] md:col-span-3">
          {data.name}
        </div>
        <div
          className={`text-sm leading-5 font-normal border-none px-2 py-1 rounded-full w-fit ${data.category == "Conference" ? "text-[#00758A] bg-[#E6F3F9]" : data.category == "Webinar" ? "text-[#9C1349] bg-[#FCEDEE]" : "text-[#00758A] bg-[#E6F3F9]"}`}
        >
          {data.category}
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-4 items-center gap-4">
        <div className="flex items-center gap-2 col-span-2">
          <div className="h-[3.25rem] w-[3.25rem] border border-[#a97979] flex flex-col justify-center items-center rounded-[4px] p-4">
            <div className="text-xs">
              {d.toLocaleString("en-US", { month: "short" })}
            </div>
            <div className="text-base font-bold">{d.getDate()}</div>
          </div>
          <div className="flex flex-col ">
            <div className="text-base font-medium">
              {formatEventDateRange(data)}
            </div>
            <div className="text-base text-[#606C73]">{data.time}</div>
          </div>
        </div>

        {(data.address_line1 || data.address_line2) && (
          <div className="flex items-center gap-2 col-span-2">
            <div className="h-[3.25rem] w-[3.25rem] border border-[#F0F0F0] flex flex-col justify-center items-center rounded-[4px]">
              <MapPin className="text-[#AFAFAF]" size={24} />
            </div>
            <div className="flex flex-col">
              <div className="text-base font-medium">{data.address_line1}</div>
              <div className="text-base text-[#606C73]">
                {data.address_line2}
              </div>
            </div>
          </div>
        )}
      </div>

      <div className="flex flex-col gap-2 overflow-y-auto">
        <h3 className="text-base font-semibold leading-6 text-[#0F1B21]">
          Overview
        </h3>
        <div className="text-base text-[#0F1B21]">{data.overview}</div>
        {data.website && (
          <div
            className="cursor-pointer flex items-center gap-2 text-[#D31710] text-sm font-medium border-b border-border-stone pb-6"
            onClick={() => {
              window.open(data.website);
            }}
          >
            <div>View {data.category} Website</div>
            <ExternalLink size={16} />
          </div>
        )}
      </div>

      {data.speaker_times && data.speaker_times.length > 0 && (
        <div className="flex flex-col gap-2 max-h-full my-8 overflow-y-hidden">
          <h3 className="text-base leading-6 font-semibold">Lilly Speakers</h3>

          <div className="overflow-y-auto flex flex-col gap-2">
            {data.speaker_times && data.speaker_times.length > 0 ? (
              data.speaker_times.map((data) => (
                <LillySpeakers data={data} key={data.id} />
              ))
            ) : (
              <div className="text-body-text-gray7 italic text-sm">
                No Speaker Data
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default EventTileDrawer;
